import mixpanel from 'mixpanel-browser';

const source = 'dashboard';

export default {
    trackTimeSelection(selectedOption) {
        mixpanel.track(`${source}:time_selected`, {
            'Selected Option': selectedOption
        });
    },

    trackDownloadedWidget({ widgetName, format }) {
        mixpanel.track(`${source}:download_widget`, {
            'Downloaded Widget': widgetName,
            format
        });
    },

    trackWidgetSharing(widgetName) {
        mixpanel.track(`${source}:share_link`, {
            'Shared Widget': widgetName
        });
    }
};
